var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.renderedComponent,{tag:"component",staticClass:"on-topic",attrs:{"title":_vm.post.title,"link":_vm.link,"thumbnail":_vm.post.thumbnail,"excerpt":_vm.post.lead,"author":_vm.post.author,"is-free":_vm.post.isFree}})}
var staticRenderFns = []

export { render, staticRenderFns }